module.exports = __webpack_public_path__ + "img/invoice-template-nz.f63d7b8.png";